import { flow, filter, includes, reject } from 'lodash/fp';

const AUDI = '060';
const BMW = '130';
const FORD = '285';
const MERCEDES_BENZ = '570';
const OPEL = '650';
const RENAULT = '720';
const VOLKSWAGEN = '905';

const topMakes = [AUDI, BMW, FORD, MERCEDES_BENZ, OPEL, RENAULT, VOLKSWAGEN];

export default flow((options) => [
  {
    label: __('options.makes.topMakes'),
    options: filter(({ value }) => includes(value, topMakes), options),
  },
  {
    label: __('options.makes.other'),
    options: reject(({ value }) => includes(value, topMakes), options),
  },
]);
